// extracted by mini-css-extract-plugin
export default {"HourlyForecast":"styles_HourlyForecast__+KG-o","heading":"styles_heading__LRbPa","itemsWrapper":"styles_itemsWrapper__Q1CfQ"};